module.exports = __webpack_public_path__ + "img/bg2@3x.85e23a0b.png";